import { jsx as c } from "react/jsx-runtime";
import { Root as f } from "@radix-ui/react-accordion";
import { useState as y } from "react";
import g from "./index.es643.js";
import { AccordionItem as N } from "./index.es644.js";
const T = "accordion", x = ({
  items: o,
  type: n = "multiple",
  testId: s = T,
  defaultOpen: i,
  open: e,
  onOpenChange: l,
  variant: b = "default",
  itemsHeadingLevel: I = "h2",
  ...u
}) => {
  const [m, S] = y(
    typeof i == "string" ? i : void 0
  ), [A, h] = y(
    Array.isArray(i) ? i : []
  ), v = (r) => o.length === 1 ? "last" : r === 0 ? "first" : r === o.length - 1 ? "last" : "mid", V = (r, t) => n === "multiple" && Array.isArray(t) ? t.includes(r) : r === t, d = (r) => o.map((t, a) => {
    const p = v(a), D = V(t.value, r);
    return /* @__PURE__ */ c(
      N,
      {
        itemPosition: p,
        isAccordionOfOne: o.length === 1,
        isAboveSelected: D,
        variant: b,
        itemsHeadingLevel: I,
        ...t,
        testId: t.testId || `${s}-item-${a}`
      },
      `${t.label}-${a}`
    );
  });
  if (n === "single") {
    const r = typeof e == "string" ? e : m;
    return /* @__PURE__ */ c(
      f,
      {
        "data-testid": s,
        className: g.root,
        type: "single",
        tabIndex: -1,
        defaultValue: typeof i == "string" ? i : void 0,
        onValueChange: (t) => {
          l && l(t), S(t);
        },
        value: r,
        "aria-label": u["aria-label"] || "Accordion",
        children: d(m || "")
      }
    );
  }
  const $ = Array.isArray(e) ? e : A;
  return /* @__PURE__ */ c(
    f,
    {
      "data-testid": s,
      className: g.root,
      type: "multiple",
      tabIndex: -1,
      defaultValue: Array.isArray(i) ? i : [],
      onValueChange: (r) => {
        l && l(r), h(r);
      },
      value: $,
      "aria-label": u["aria-label"] || "Accordion",
      children: d(A)
    }
  );
};
export {
  T as ACCORDION_DEFAULT_TESTID,
  x as Accordion
};
//# sourceMappingURL=index.es5.js.map
